export class TruckerSearchParameters {
    customerName: string = '';
    city: string = '';
    customerCode: string = '';
    truckerStartDate: string = '';
    truckerEndDate: string = '';
    hasChanged: boolean = false;
}